/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const PhoneNumber = zod.object({
  phoneNumber: zod.string().describe('The phone number in E.164 format'),
  primary: zod.boolean().describe('True for the primary number (the profile phone number)'),
  verified: zod.boolean().describe('True once the number has passed SMS OTP verification'),
});

export type PhoneNumber = zod.input<typeof PhoneNumber>;
export type PhoneNumberOutput = zod.output<typeof PhoneNumber>;
